// extracted by mini-css-extract-plugin
export default {"shortcut":"XFO2","shortcut-title-wrapper":"zTH8","shortcutTitleWrapper":"zTH8","icon":"RDzo"};